<template>
	<transition mode="out-in" name="leftIn">
		<div v-if="setores.result && ramais.result" class="row">
			<div v-for="setor in setores.result" :key="setor.ID" class="col-xl-4 col-lg-6 mb-3">

				<div class="card border-left-primary shadow h-100 py-2">
	                <div class="card-body">
	                    <div class="row no-gutters align-items-center">
	                        <div class="col mr-2">
	                            <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ setor.NAME }}</div>

								<div v-for="ramal in ramais.result" :key="ramal.ID">
									<div v-if="ramal.PARENT_ID == setor.ID" class="row no-gutters align-items-center">
	                                    <div class="col-auto">
	                                        <div class="col-1 col-lg-1 col-xl-1">
	                                        	<font-awesome-icon v-if="ramal.STATUS == 1" icon="phone" size="xs" style="color: red" />
	                                        	<font-awesome-icon v-else icon="phone" size="xs" style="color: green" />
	                                        </div>
	                                    </div>

	                                    <div class="col">
	                                        <div class="col-12 col-lg-12 col-xl-12">
	                                            <small>{{ ramal.NAME }}</small> - <small>{{ ramal.EXTENSION }}</small>
	                                        </div>
	                                    </div>
	                                </div>
								</div>

	                        </div>
	                        <div class="col-auto">
	                            <i class="fas fa-phone fa-2x text-gray-300"></i>
	                        </div>
	                    </div>
	                </div>
	            </div>

			</div>
		</div>

		<div v-else><Loading/></div>
	</transition>
</template>

<script>
	import api from "@/mixins/api.js"

    export default {
    	name: "Ramais",
    	mixins: [api],

    	data: () => { return {
    		setores: { status: null, result: null },
			ramais:  { status: null, result: null },
			looping: null
    	}},

    	created() {
    		this.get_setores()
			this.get_ramais()
			this.$emit('update:form_date', false)
    	},

    	methods: {
    		async get_setores() {
    			this.setores = await this.GET("Setor")
    		},

    		async get_ramais() {
				this.ramais = await this.GET("Ramal")
				this.refresh()
			},

            refresh() {
                clearTimeout(this.looping)
                this.looping = setTimeout( () => this.get_ramais(), 2000)
            },
    	}
    }
</script>

<style scoped>
</style>